import StorageService from '@/services/storage-service'
import PageApi from '@/api/page'

export default {
  namespaced: true,
  state: {
    currentPageId: StorageService.getItem('bya3com_page', null),
    pages: [],
    fetchedSettings: {},
    addPageTour: false,
    features: [],
    fetchedFeatures: false,
  },
  getters: {
    pages: (state: any) => state.pages ?? [],
    features: (state: any) => state.features ?? [],
    hasFeatures: (state: any, getters: any) => (feature: string) => (getters.currentPage?.features ?? []).find((f: any) => f.slug === feature),
    hasLikesFeature: (state: any, getters: any) => getters.hasFeatures('likes'),
    hasCommenterFeature: (state: any, getters: any) => getters.hasFeatures('comments'),
    currentPageId: (state: any) => state.currentPageId,
    currentPage: (state: any) => state.pages.find((page: any) => page.id === state.currentPageId) ?? {},
    webviewEnabled: (state: any, getters: any) => getters.currentPage.domain && (getters.currentPage.has_store || getters.currentPage.has_bot),
    /**
     * FB dashboard “API / AI” features: new_app page and pool headroom
     * (sum of ai_replies_count on page replies vs page ai_limit; 0 = unlimited).
     */
    pageCanUseApi: (state: any, getters: any) => {
      const p = getters.currentPage
      if (p.ai_enabled === false) return false
      return !!p?.can_use_api
    },
    addPageTour: (state: any) => state.addPageTour,
    isPageHasFeature: (state: any, getters: any) => (feature: string) => getters.currentPage?.[feature] ?? false,
  },
  mutations: {
    SET_PAGES(state: any, pages: Array<any>) {
      state.pages = pages
      if (!state.currentPageId || !pages.find(b => b.id === state.currentPageId)) {
        state.currentPageId = pages[0]?.id
      }
    },
    SET_PAGE(state: any, pageId: number) {
      state.currentPageId = pageId
    },
    SET_FETCHING_SETTINGS(state: any, pageId: number) {
      state.fetchedSettings[pageId] = true
    },
    RESET(state: any) {
      state.fetchedSettings = {}
    },
    SET_ADD_PAGE_TOUR(state: any, visible = true) {
      state.addPageTour = visible
    },
    SET_FEATURES(state: any, features: any) {
      state.features = features
      state.fetchedFeatures = true
    },
  },
  actions: {
    SET_PAGE(context: any, pageId: number) {
      context.commit('SET_PAGE', pageId)

      if (!context.rootGetters['auth/impersonate']) {
        StorageService.setItem('bya3com_page', pageId)
      }
    },
    async GET_PAGES(context: any) {
      return context.getters.pages.length
    },
    UPDATE_PAGE(context: any, page: any) {
      const pageIdx = context.state.pages.findIndex((b: any) => b.id === page.id)
      const pages = [...context.state.pages]
      if (pageIdx >= 0) {
        pages[pageIdx] = {
          ...pages[pageIdx],
          ...page,
        }
      } else {
        pages.push(page)
      }
      context.commit('SET_PAGES', pages)
      return page
    },
    async GET_PAGE_FEATURES(context: any) {
      if (context.state.fetchedFeatures) return
      await PageApi.getPageFeatures().then((data: any) => {
        context.commit('SET_FEATURES', data?.features ?? [])
      }).catch(() => {
      })
    },
  },
}
